// Lightweight lazy loading + legacy perf kit compatibility
// Updated 2025-11-28 to fix CPU usage & LCP issues

var src, srcset, wnw_windowWidth, wnw_windowHeight, critical2, cls_css,
    lazyBackground, lazyIframe, lazybg, lazybg2, s, i,
    flag = 1,
    external_single_loaded = 1;

// Helper: update viewport size (safer than screen.*)
function wnw_updateWindowSize() {
  wnw_windowWidth = window.innerWidth || document.documentElement.clientWidth || screen.width;
  wnw_windowHeight = window.innerHeight || document.documentElement.clientHeight || screen.height;
}

document.addEventListener("DOMContentLoaded", function () {
  wnw_updateWindowSize();

  // Load anything already in/near viewport
  lazyLoadImg2();
  lazyLoadBackground2();

  // Run main init shortly after first paint
  setTimeout(wnw_init, 200); // was only on scroll/mousemove/touch/8s

  // Scroll/touch will re-run init as user interacts
  window.addEventListener(
    "scroll",
    wnw_init,
    { passive: true }
  );

  window.addEventListener(
    "touchstart",
    wnw_init,
    { passive: true }
  );

  // Fallback: make sure things are initialized even on no interaction
  setTimeout(wnw_init, 3000); // was 8000ms
});

// Core lazy init
function wnw_init() {
  // Remove temporary CLS CSS if present
  cls_css = document.querySelectorAll(".cls_css");
  cls_css.forEach(function (a) {
    a.remove();
  });

  // Load deferred assets
  lazyLoadCss();
  lazyLoadStyle();
  lazyLoadImg();
  lazyLoadBackground();
  lazyLoadIframe();

  // Run JS loader once
  if (flag) {
    flag = 0;
    load_all_js();
  }
}

function insertAfter(newNode, referenceNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

/* =====================
   IMAGE LAZY LOADING
   ===================== */

function lazyLoadImg() {
  var imgs = document.querySelectorAll("img.lazy2");

  for (i = 0; i < imgs.length; i++) {
    if (wnw_windowWidth < 600) {
      src = (imgs[i].dataset.mobsrc === undefined) ? imgs[i].dataset.src : imgs[i].dataset.mobsrc;
    } else {
      src = (imgs[i].dataset.src === undefined) ? imgs[i].src : imgs[i].dataset.src;
    }
    srcset = imgs[i].getAttribute("data-srcset") ? imgs[i].getAttribute("data-srcset") : "";
    if (src != null && src !== "") {
      imgs[i].src = src;
    }
    if (srcset != null && srcset !== "") {
      imgs[i].srcset = srcset;
    }
    imgs[i].classList.remove("lazy2");
  }
}

function lazyLoadImg2() {
  var imgs = document.querySelectorAll("img.lazy3");

  for (i = 0; i < imgs.length; i++) {
    var elemRect = imgs[i].getBoundingClientRect();
    if (elemRect.top !== 0 && elemRect.top - wnw_windowHeight < 0) {
      if (wnw_windowWidth < 600) {
        src = (imgs[i].dataset.mobsrc === undefined) ? imgs[i].dataset.src : imgs[i].dataset.mobsrc;
      } else {
        src = (imgs[i].dataset.src === undefined) ? imgs[i].src : imgs[i].dataset.src;
      }
      srcset = imgs[i].getAttribute("data-srcset") ? imgs[i].getAttribute("data-srcset") : "";
      if (src != null && src !== "") {
        imgs[i].src = src;
      }
      if (srcset != null && srcset !== "") {
        imgs[i].srcset = srcset;
      }
      imgs[i].classList.remove("lazy3");
    }
  }
}

/* ==========================
   BACKGROUND LAZY LOADING
   ========================== */

function lazyLoadBackground() {
  lazyBackground = document.querySelectorAll(".lazybg");
  lazyBackground.forEach(function (a) {
    if (wnw_windowWidth < 600) {
      lazybg = (a.dataset.mobstyle === undefined) ? a.dataset.style : a.dataset.mobstyle;
    } else {
      lazybg = (a.dataset.style === undefined) ? a.style : a.dataset.style;
    }
    if (lazybg != null && lazybg !== "") {
      a.style = lazybg;
    }
    a.classList.remove("lazybg");
  });
}

function lazyLoadBackground2() {
  lazyBackground = document.querySelectorAll(".lazybg2");
  lazyBackground.forEach(function (a) {
    var elemRect = a.getBoundingClientRect();
    if (elemRect.top !== 0 && elemRect.top - wnw_windowHeight < 0) {
      if (wnw_windowWidth < 600) {
        lazybg = (a.dataset.mobstyle === undefined) ? a.dataset.style : a.dataset.mobstyle;
      } else {
        lazybg = (a.dataset.style === undefined) ? a.style : a.dataset.style;
      }
      if (lazybg != null && lazybg !== "") {
        a.style = lazybg;
      }
      a.classList.remove("lazybg2");
    }
  });
}

/* =====================
   CSS / STYLE LAZY
   ===================== */

function lazyLoadCss() {
  var lazyLink = document.querySelectorAll("link[data-href]");
  for (i = 0; i < lazyLink.length; i++) {
    var css_element = document.createElement("link");
    css_element.href = lazyLink[i].getAttribute("data-href");
    css_element.rel = "stylesheet";
    lazyLink[i].parentNode.insertBefore(css_element, lazyLink[i]);
    delete lazyLink[i].dataset.href;
    lazyLink[i].parentNode.removeChild(lazyLink[i]);
  }
}

function lazyLoadStyle() {
  var lazyStyle = document.querySelectorAll("style[type=lazyload2]");
  for (i = 0; i < lazyStyle.length; i++) {
    var style_element = document.createElement("style");
    style_element.innerHTML = lazyStyle[i].innerHTML;
    lazyStyle[i].parentNode.insertBefore(style_element, lazyStyle[i]);
    lazyStyle[i].parentNode.removeChild(lazyStyle[i]);
  }
}

/* =====================
   IFRAME LAZY
   ===================== */

function lazyLoadIframe() {
  lazyIframe = document.querySelectorAll("iframe");
  lazyIframe.forEach(function (a) {
    if (a.dataset.src != null && a.dataset.src !== "") {
      a.src = a.dataset.src;
      delete a.dataset.src;
    }
  });
}

/* =====================
   SCRIPT LOADER (LEGACY)
   ===================== */

function w3_load_js_uri(static_script) {
  var ext_js_element = document.createElement("script");
  if (typeof static_script.attributes !== "undefined") {
    for (var att, i3 = 0, atts = static_script.attributes, n3 = atts.length; i3 < n3; i3++) {
      att = atts[i3];
      if (att.nodeName !== "data-src" && att.nodeName !== "type") {
        ext_js_element.setAttribute(att.nodeName, att.nodeValue);
      }
    }
  }
  ext_js_element.src = static_script.getAttribute("data-src");
  insertAfter(ext_js_element, static_script);
  delete static_script.dataset.src;
  delete static_script.type;
  static_script.parentNode.removeChild(static_script);
  return ext_js_element;
}

function w3_load_inline_js_single(script) {
  if (!external_single_loaded) {
    setTimeout(function () {
      w3_load_inline_js_single(script);
    }, 200);
    return false;
  }
  s = document.createElement("script");
  for (var i2 = 0; i2 < script.attributes.length; i2++) {
    var attrib = script.attributes[i2];
    if (attrib.name !== "type") {
      s.setAttribute(attrib.name, attrib.value);
    }
  }
  s.innerHTML = script.innerHTML;
  insertAfter(s, script);
  script.parentNode.removeChild(script);
}

function lazyLoadScripts() {
  var static_script = document.querySelectorAll("script[type=lazyload2]");
  if (static_script.length < 1) {
    document.body.classList.add("wnw_loaded");
    fullJSLoadedCB();
    return;
  }
  if (static_script[0].getAttribute("data-src") !== null) {
    var js_obj = w3_load_js_uri(static_script[0]);
    js_obj.onload = function () {
      lazyLoadScripts();
    };
    js_obj.onerror = function () {
      lazyLoadScripts();
    };
  } else {
    w3_load_inline_js_single(static_script[0]);
    lazyLoadScripts();
  }
}

// NOTE: This used to fiddle with Shopify's trekkie analytics.
// We leave it intact but minimal to avoid duplicating analytics.
function wnwAnalytics() {
  var script2 = document.querySelectorAll(".analytics");
  script2.forEach(function (analyticsScript) {
    try {
      if (window.trekkie) {
        // do not hard-disable trekkie integrations anymore
      }
    } catch (e) {}
    s = document.createElement("script");
    s.innerHTML = analyticsScript.innerHTML;
    insertAfter(s, analyticsScript);
    analyticsScript.parentNode.removeChild(analyticsScript);
  });
}

/* =====================
   MASTER JS LOADER
   ===================== */

function load_all_js() {
  if (Shopify.designMode || window.location.href.indexOf("cart") > -1 || window.location.href.indexOf("checkout") > -1) {
    console.log("wnw perf: no optimization on cart/checkout/design mode");
  } else {
    console.log("wnw perf: optimized lazy load");
    setTimeout(function () {
      wnwAnalytics();
    }, 100);

    // Legacy custom events support (no longer used by theme, but harmless)
    setTimeout(function () {
      var wnw_load_event = document.createEvent("Event");
      wnw_load_event.initEvent("wnw_load", true, true);
      window.document.dispatchEvent(wnw_load_event);
    }, 500);

    setTimeout(function () {
      var DOMContentLoaded2_event = document.createEvent("Event");
      DOMContentLoaded2_event.initEvent("DOMContentLoaded2", true, true);
      window.document.dispatchEvent(DOMContentLoaded2_event);
    }, 5000);
  }

  // Load any remaining lazy scripts
  lazyLoadScripts();

  // Clean up critical CSS markers after ~10s
  setTimeout(function () {
    critical2 = document.querySelectorAll(".critical2");
    critical2.forEach(function (a) {
      a.remove();
    });
  }, 9999);

  // IMPORTANT FIX: give setInterval a reasonable delay (was 0ms = CPU hammer)
  setInterval(function () {
    lazyLoadImg();
    lazyLoadIframe();
  }, 3000); // run every 3s instead of continuously
}

function fullJSLoadedCB() {
  // Placeholder hook for when all lazy JS has finished loading
  setTimeout(function () {}, 0);
}
